import React, { useState } from "react";
import { HelpCircle } from "lucide-react";

export const HelpHint = ({ text, testid, align = "left" }) => {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex align-middle">
      <button type="button" data-testid={testid} aria-label="Aiuto"
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setTimeout(() => setOpen(false), 180)}
        className="text-[#8a97a8] hover:text-[#33559d] transition-colors">
        <HelpCircle size={15} />
      </button>
      {open && (
        <span className={`absolute z-[80] top-6 ${align === "right" ? "right-0" : "left-0"} w-64 p-2.5 rounded-[4px] bg-[#1f2a3a] text-white text-[11px] leading-relaxed shadow-xl normal-case tracking-normal font-400`}>
          {text}
        </span>
      )}
    </span>
  );
};

export default HelpHint;
